import React from 'react';
import PropTypes from 'prop-types';
import { Pagination as BootstrapPagination, CardFooter, PaginationItem, PaginationLink} from "reactstrap";
import { Input } from "stories/forms"
import './Table.css';

export const Pagination = ({ 
    className, 
    paginationPrevious, 
    paginationNext, 
    paginationGoPage, 
    paginationLimit, 
    paginationOffset,
    paginationCount,
    setFilters,
    showPaginationLimitSelect,
    showPaginationNextAndPrevious = true,
    showPaginationCurrentPage = true,
    showVerticalBorders = true,
    name="limit",
    footerActions = null,
    limitOptions = [
      { value: 10000, label: 'Kaikki' },
      { value: 30, label: '30' },
      { value: 50, label: '50' },
      { value: 100, label: '100' },
      { value: 300, label: '300' }
    ]
  }) => {
  

  const getCurrentPageNum = () => {
    if (paginationOffset === 0) {
      return 1;
    }
    return (Math.ceil(paginationOffset / paginationLimit) + 1 )// how to round this up? M

  

  }
  
  const getMaxPageNum = () => {
    const max_page_num = Math.ceil(paginationCount / paginationLimit);

    
    
    if (max_page_num < 1) {
      return 1;
    }
    //if max_page_num cant be divided by paginationLimit, then add 1 to max_page_num
    if (paginationOffset % paginationLimit !== 0) {
      return max_page_num + 1;
    }
    return max_page_num;
  }
  
  const handleFilterChange = ({ target }) => {
    const { value, name } = target;
    setFilters(s => ({
      ...s,
      [name]: Number(value)
    }))
  }

  return (
    <CardFooter className={showVerticalBorders ? "py-4": "p-0"} style={showVerticalBorders ? null : {borderTop: "0px"}}>
      <div className={`d-flex flex-wrap align-items-center w-100 ${footerActions ? "justify-content-between" : "justify-content-end"}`}>
        {footerActions}
      <nav aria-label="...">
        <BootstrapPagination
          className="pagination justify-content-end mb-0"
          listClassName="justify-content-end mb-0"
        >
          <div className="d-flex flex-row">
            
            { showPaginationLimitSelect && (
            <div className="align-self-center mr-1">
              <Input type="select" name={name} onChange={handleFilterChange} value={paginationLimit}>
                {limitOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </div>
            )}
            
            { showPaginationNextAndPrevious && (
              <>
            <div className="align-self-center">
            <PaginationItem className={paginationOffset === 0 ? "disabled" : ""}>
              <PaginationLink
                onClick={paginationPrevious}
                tabIndex="-1"
              >
                <i className="fas fa-angle-left" />
                <span className="sr-only">Previous</span>
              </PaginationLink>
            </PaginationItem>
            </div>
            <div className="align-self-center">
            <PaginationItem className={(paginationOffset > paginationCount - paginationLimit) ? "disabled" : ""}>
              <PaginationLink
                onClick={paginationNext}
              >
                <i className="fas fa-angle-right" />
                <span className="sr-only">Next</span>
              </PaginationLink>
            </PaginationItem>
            </div>
            </>
            )}

            {/*
            <PaginationItem className="active">
              <PaginationLink
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                1
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                2 <span className="sr-only">(current)</span>
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                3
              </PaginationLink>
            </PaginationItem>
            */}
      
            { showPaginationCurrentPage && (
            <div className="align-self-center pl-2">
            <PaginationItem>
              {getCurrentPageNum()} / {getMaxPageNum()}
            </PaginationItem>
            </div>
            )}
          </div>
        </BootstrapPagination>
      </nav>
      </div>
    </CardFooter>
  )
    
}

Pagination.propTypes = {
  paginationPrevious: PropTypes.func,
  paginationNext: PropTypes.func,
  paginationLimit: PropTypes.number,
  paginationOffset: PropTypes.number,
  paginationCount: PropTypes.number,
  setFilters: PropTypes.func,
  showPaginationLimitSelect: PropTypes.bool,
  showPaginationNextAndPrevious: PropTypes.bool,
  showPaginationCurrentPage: PropTypes.bool,
  showVerticalBorders: PropTypes.bool,
  name: PropTypes.string,
  footerActions: PropTypes.node,
  limitOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

Pagination.defaultProps = {
  paginationLimit: 1,
  paginationOffset: 0,
  paginationCount: 0,
  showPaginationLimitSelect: true,
  limitOptions: [
    { value: 10000, label: 'Kaikki' },
    { value: 30, label: '30' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
    { value: 300, label: '300' }
  ],
};

/* USAGE EXAMPLE

const paginationPrevious = () => {
  let offset = filters?.offset - filters?.limit;
  if (offset < 0) {
    offset = 0;
  }
  setFilters(f => ({
    ...f,
    offset: offset,
  }))
}

const paginationNext = () => {
  let offset = filters?.offset + filters?.limit;
  if (offset > filters?.count) {
    return
  }
  setFilters(f => ({
    ...f,
    offset: offset,
  }))
}

// Basic usage (with default limit options)
<Pagination 
  paginationPrevious={paginationPrevious}
  paginationNext={paginationNext}
  paginationOffset={filters?.offset}
  paginationLimit={filters?.limit}
  paginationCount={count}
  setFilters={setFilters}
  showPaginationLimitSelect={true}
/>

// Custom limit options
<Pagination 
  paginationPrevious={paginationPrevious}
  paginationNext={paginationNext}
  paginationOffset={filters?.offset}
  paginationLimit={filters?.limit}
  paginationCount={count}
  setFilters={setFilters}
  showPaginationLimitSelect={true}
  limitOptions={[
    { value: 2, label: '2' },
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 10000, label: 'All' }
  ]}
/>

*/
